/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Home_query_partners = {
    readonly partners: {
        readonly items: ReadonlyArray<{
            readonly _children: {
                readonly items: ReadonlyArray<{
                    readonly partnerSiteUrl?: string | null;
                    readonly picture?: string;
                    readonly _name?: string | null;
                    readonly _id?: string;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "Home_query_partners";
};
export type Home_query_partners$data = Home_query_partners;
export type Home_query_partners$key = {
    readonly " $data"?: Home_query_partners$data;
    readonly " $fragmentRefs": FragmentRefs<"Home_query_partners">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Home_query_partners",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PartnersPublishedContentConnection",
      "kind": "LinkedField",
      "name": "partners",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PartnersPublishedContent",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "orderBy",
                  "value": "_updateDate_DESC"
                }
              ],
              "concreteType": "PublishedContentConnection",
              "kind": "LinkedField",
              "name": "_children",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "partnerSiteUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "picture",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "_name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "_id",
                          "storageKey": null
                        }
                      ],
                      "type": "PartnerPublishedContent",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "_children(orderBy:\"_updateDate_DESC\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PublishedContentByTypeQuery",
  "abstractKey": null
};
(node as any).hash = 'd9cb0cf1e45ab7376bfc58c5e72d48a6';
export default node;
